export default {
      id: "help__unit_icon-usage",
      viewBox: "0 0 51 37",
      url: __webpack_public_path__ + "img/icons.svg#help__unit_icon",
      toString: function () {
        return this.url;
      }
    }